import React, { Component } from 'react';
import { Dialog, Button, DialogTitle, DialogContent, DialogActions, DialogContentText, Icon, TextField, Snackbar } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Http from '../../Http';
import { DownloadFileComponent } from "../../helpers";
import './acciones.css'
import { AuthContext } from '../../context/authContext';
import Pdf from '../pdfViewer'
import ACCESS from '../../ACCESS';

class AccionesGuia extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openSG: false,
      openSF: false,
      openPrint: false,
      openEtq: false,
      cantEtiquetas: props.guia.g_piezas || 1,
      alertDialog: {
        open: false,
        title: '',
        content: '',
        onCancel: () => { },
        onAccept: () => { },
      },
      snackbar: {
        open: false,
        message: '',
      },
      searchOptions: [],
      searcFoliohOptions: [],
      pdfURL: '',
      loadingAccpImp: false,
      loadingAccEtq: false,
      g_folio: props.guia.g_folio ? props.guia.g_folio : false,
    }
  }


  componentDidMount() {
    // console.log(this.context);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.guia.g_piezas !== this.props.guia.g_piezas) {
      this.setState({
        cantEtiquetas: this.props.guia.g_piezas
      })
    }
  }

  setOpenSg = (openSG) => {
    this.setState({ openSG })
  }
  setOpenSF = (openSF) => {
    this.setState({ openSF })
  }
  setOpenPrint = (openPrint) => {
    this.setState({ openPrint, loadingVisImp: openPrint })
  }
  setAlertDialog = (alertDialog) => {
    this.setState({ alertDialog })
  }
  setSnackbar = (snackbar) => {
    this.setState({ snackbar })
  }
  setSearchOptions = (searchOptions) => {
    this.setState({ searchOptions })
  }
  setSearcFoliohOptions = (searcFoliohOptions) => {
    this.setState({ searcFoliohOptions })
  }
  setPdfURL = (pdfURL) => {
    this.setState({ pdfURL })
  }
  setCantEtiquetas = (cantEtiquetas) => {
    this.setState({ cantEtiquetas })
  }
  setOpenEtq = (openEtq) => {
    this.setState({ openEtq })
  }

  preguiaSelectChange = async (value) => {
    this.props.history.push(`/Guias/Guia/${value.id}`);
    this.setOpenSg(false)
  }

  folioSelectChange = async (value) => {
    await this.props.onSelectFolio(value)
    this.setOpenSF(false);
  }

  valueFolioSearchChange = async (value) => {
    const Res = await Http.get(`cliente-folios/search?search=${value}`);
    if (!Res.error) {
      this.setSearcFoliohOptions(Res.data)
    }
  }

  valueSearchChange = async (value) => {
    const Res = await Http.get(`guia/form?guia_folio=${value}`);
    if (!Res.error) {
      const { guias } = Res.data;
      this.setSearchOptions(guias);
    }
  }

  handleCancelClick = (type = 1) => {
    this.setAlertDialog({
      open: true,
      title: 'Cancelar Guía',
      content: '¿Realmente Quiere Cancelar la Guía?',
      onAccept: () => { this.handleCancelGuia(type) },
      onCancel: () => { },
    });
  }

  handlePrintClick = async (id, folio, precios = false) => {
    // const Resp = await Http.get(`Prueba?id=${id ? id : this.props.guia.id_guia}`, true, 'arraybuffer');
    this.setState({ loadingVisImp: true });
    const Resp = await Http.get(`guia-impresion/recibo/${id ? id : this.props.guia.id_guia}?precios=${precios}`, true, 'arraybuffer');
    if (Resp) {
      this.id_guia = id ? id : this.props.guia.id_guia;
      const blob = new Blob([Resp], { type: 'application/pdf' });
      const pdfURL = await URL.createObjectURL(blob);
      this.setState({ 
        openPrint: true, 
        loadingVisImp: false,
        pdfURL,
        type_print: 'guia',
        folio
      });
    }
    // this.setState({ loadingVisImp: false });
  }

  handlePrintEtiqueta = async (id) => {
    this.setState({
      loadingAccEtq: true
    })
    const { cantEtiquetas } = this.state;
    const Resp = await Http.get(`guia-impresion/etiqueta/${this.id_guia ? this.id_guia : this.props.guia.id_guia}?bultos=${cantEtiquetas}`, true, 'arraybuffer');
    if (Resp) {
      this.id_guia = id;
      const blob = new Blob([Resp], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      this.setState({
        pdfURL: url,
        openPrint: true, 
        loadingVisImp: true,
        openEtq: false,
        loadingAccEtq: false,
        type_print: 'etq'
      });
      // this.setOpenEtq(false)
    }
  }

  handlePrintPdfEtiqueta = async () => {
    const { pdfURL, alertDialog } = this.state;
    const printWin = window.open(pdfURL, 'Etiqueta', 'width=1050,height=800');
    printWin.focus();
    printWin.print();
    URL.revokeObjectURL(pdfURL);
    this.setPdfURL('');
    this.setAlertDialog({ ...alertDialog, open: false });
    this.setOpenPrint(false);
    if (this.id_guia) {
      this.props.history.push(`/Guias/Todas`);
    }
  }

  handlePrintPdf = async () => {
    const { pdfURL, alertDialog } = this.state;
    const { modo } = this.props;
    this.setState({ loadingAccpImp: true });
    const Resp = await Http.post(`guia/${this.id_guia || this.props.guia.id_guia}/imprimir`);
    if (!Resp.error) {
      const printWin = window.open(pdfURL, 'GUIA', 'width=1050,height=800');
      printWin.focus();
      printWin.print();
      URL.revokeObjectURL(pdfURL);
      this.setState({
        pdfURL: '',
        alertDialog: { ...alertDialog, open: false },
        openPrint: false, 
        loadingVisImp: false,
        loadingAccpImp: false,
      });
      // esto es cuando se imprime al momento de crearla
      if (modo !== 'edit') {
        // 
        this.setState({
          alertDialog: {
            open: true,
            title: 'Imprimir etiquetas',
            content: '¿Quiere imprimir las etiquetas?',
            onCancel: () => {
              this.props.history.push(`/Guias/Todas`);
             },
            onAccept: () => { 
              this.handlePrintEtiquetaClick(this.id_guia)
            },
          }
        })
      }
    } else {
      this.setSnackbar({
        open: true,
        message: 'Ocurrio un error al imprimir la Guía'
      });
    }
  }

  handlePrintEtiquetaClick = async (id) => {
    this.setOpenEtq(true);
  }

  handleCancelGuia = async (type) => {
    const { alertDialog } = this.state;
    this.setAlertDialog({ ...alertDialog, open: false })
    let url_cancel = '';
    if (type === 1) {
      url_cancel = `guia/${this.props.guia.id_guia}/cancelar`;
    } else {
      url_cancel = `guia/${this.props.guia.id_guia}/cancelar-all`;
    }
    const Resp = await Http.post(url_cancel);
    if (!Resp.error) {
      this.setSnackbar({ open: true, message: 'Guía Cancelada' });
      window.location.reload();
    } else {
      this.setSnackbar({
        open: true,
        message: Resp.errMsg || Resp.message || 'Ocurrió un error al cancelar la Guía'
      });
    }
  }

  handleRedocClick = () => {
    const { alertDialog } = this.state;
    this.setAlertDialog({
      open: true,
      title: 'Re Documentar Guía',
      content: '¿Realmente Quieres Re documentar la Guía?',
      onAccept: () => { this.setAlertDialog({ ...alertDialog, open: false }); this.props.onRedocumentar(); },
      onCancel: () => { },
    });
  }

  handleAcceptPrint = () => {
    const { alertDialog } = this.state;
    if (this.props.guia.g_impresa) {
      this.handlePrintPdf();
    } else {
      this.setAlertDialog({
        ...alertDialog,
        open: true,
        title: 'Imprimir Guía',
        content: 'Al Aceptar la guía se marcara como impresa',
        onAccept: this.handlePrintPdf,
        onCancel: () => {
          // esto es cuando se imprime al momento de crearla
          if (this.id_guia) {
            this.props.history.push(`/Guias/Todas`);
          }
        },
      })
    }
  }

  handleMailClick = () => {
    const { alertDialog } = this.state;
    this.setAlertDialog({
      ...alertDialog,
      open: true,
      title: 'Reenviar Correo',
      content: 'Se enviara la guia al cliente',
      onAccept: async () => {
        this.setState({ disabledLoading: true });
        const Res = await Http.get(`guia/${this.id_guia || this.props.guia.id_guia}/resend-email`);
        if (!Res.error) {
          this.setAlertDialog({
            ...alertDialog,
            open: false,
          });
          this.setSnackbar({
            open: true,
            message: 'Correos enviados'
          })
        }
        this.setState({ disabledLoading: false });
      },
      onCancel: () => {
        this.setAlertDialog({
          ...alertDialog,
          open: false,
        });
        this.setSnackbar({
          open: true,
          message: 'Ocurrio un error al enviar los correos'
        })
      },
    })
  }

  render() {
    const { modo, guia } = this.props;
    const { hasAccess } = this.context;
    const { openSG, searchOptions, openSF, pdfURL, searcFoliohOptions,
      openPrint, alertDialog, snackbar, cantEtiquetas, openEtq, loadingVisImp = false, 
      loadingAccpImp, loadingAccEtq, type_print, folio, disabledLoading = false } = this.state;

    const mayRedoc = hasAccess(ACCESS.GUIA.REDOCUMENTAR);

    return (
      <div style={{ margin: '12px 10px', padding: '16px', backgroundColor: '#ffffff', borderRadius: '12px', border: '1px solid #e2e8f0', boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.05)' }} >
        <DownloadFileComponent />
        <h4 style={{ margin: '0 0 12px 0', color: '#1e293b', fontWeight: 600 }}>Estado: <span style={{ color: '#2563eb' }}>{guia.g_estado_descripcion}</span></h4>
        <div className="guia-actions-toolbar" >
          {/* {
            <Button
              variant="contained"
              endIcon={<Icon>search</Icon>}
              onClick={() => { this.setOpenSg(!openSG) }}
            >
              Buscar
            </Button>
          } */}
          {hasAccess(ACCESS.GUIA.IMPRIMIR) && ![0,21].includes(guia.g_estado) && modo === 'edit' && (
            <Button
              variant="contained"
              endIcon={<Icon>print</Icon>}
              onClick={() => this.handlePrintClick(false, false, false)}
              disabled={loadingVisImp}
            >
              Visualizar Impresion
            </Button>
          )}
          {hasAccess(ACCESS.GUIA.IMPRIMIR_CON_PRECIOS) && ![0,21].includes(guia.g_estado) && modo === 'edit' && (
            <Button
              variant="contained"
              endIcon={<Icon>print</Icon>}
              onClick={() => this.handlePrintClick(false, false, true)}
              disabled={loadingVisImp}
            >
              Visualizar Impresion Precios
            </Button>
          )}
          {hasAccess(ACCESS.GUIA.REENVIAR_EMAIL) && ![0,21].includes(guia.g_estado) && modo === 'edit' && (
            <Button
              variant="contained"
              endIcon={<Icon>mail</Icon>}
              onClick={() => this.handleMailClick()}
              disabled={loadingVisImp}
            >
              Reenviar Correo al cliente
            </Button>
          )}
          {hasAccess(ACCESS.GUIA.IMPRIMIR_ETIQUETAS) && ![0,21].includes(guia.g_estado) && modo === 'edit' && (
            <Button
              variant="contained"
              onClick={() => this.handlePrintEtiquetaClick()}
            >
              Imprimir Etiqueta
            </Button>
          )}
          {(![0,21,20].includes(guia.g_estado) && modo === 'edit' && mayRedoc &&
            <Button
              color="secondary"
              variant="contained"
              endIcon={<Icon>replay</Icon>}
              onClick={this.handleRedocClick}
            >
              Re Documentar
            </Button>
          )}
          {(hasAccess([ACCESS.GUIA.CANCELAR_GUIAS_CREADAS_POR_EL_USUARIO, ACCESS.GUIA.CANCELAR_GUIAS_DE_SUCURSAL_DEL_USUARIO,
            ACCESS.GUIA.CANCELAR_TODAS_GUIAS]) &&  ![0,21,1].includes(guia.g_estado) && guia.today_guia && modo === 'edit' &&
            <Button
              color="secondary"
              variant="contained"
              endIcon={<Icon>block</Icon>}
              onClick={() => this.handleCancelClick(1)}
            >
              Cancelar Guía
        </Button>
          )}
          {(hasAccess(ACCESS.GUIA.CANCELAR_SIN_RESTRICCIONES) && modo === 'edit' &&
            <Button
              color="secondary"
              variant="contained"
              endIcon={<Icon>block</Icon>}
              onClick={() => this.handleCancelClick(2)}
            >
              Cancelar Guía Sin Restricciones
            </Button>
          )}
        </div>

        <div>
          {/* BUSQUEDA DE GUIAS */}
          <Dialog onClose={() => { this.setOpenSg(false) }} open={openSG}>
            <DialogTitle onClose={() => { this.setOpenSg(false) }}>
              Buscar Guia
          </DialogTitle>
            <DialogContent dividers>
              <div>
                <Autocomplete
                  options={searchOptions}
                  disableClearable
                  getOptionLabel={option => option.g_folio}
                  onChange={(e, val) => { this.preguiaSelectChange(val) }}
                  renderInput={params => (
                    <TextField
                      style={{ minWidth: '200px' }}
                      {...params}
                      label='Buscar guia'
                      variant="outlined"
                      onChange={(e) => { this.valueSearchChange(e.target.value) }}
                      margin="normal"
                    />
                  )}
                />
              </div>
            </DialogContent>
          </Dialog>

          {/* BUSQUEDA DE FOLIOS */}
          <Dialog onClose={() => { this.setOpenSF(false) }} open={openSF}>
            <DialogTitle onClose={() => { this.setOpenSF(false) }}>
              Buscar Folio
          </DialogTitle>
            <DialogContent dividers>
              <div>
                <Autocomplete
                  options={searcFoliohOptions}
                  disableClearable
                  getOptionLabel={option => option.folio}
                  onChange={(e, val) => { this.folioSelectChange(val) }}
                  renderInput={params => (
                    <TextField
                      style={{ minWidth: '200px' }}
                      {...params}
                      label='Buscar Folio'
                      variant="outlined"
                      onChange={(e) => { this.valueFolioSearchChange(e.target.value) }}
                      margin="normal"
                    />
                  )}
                />
              </div>
            </DialogContent>
          </Dialog>

          {/* VISUALIZAR IMPRESION */}
          <Dialog fullWidth={true} maxWidth={'lg'} onClose={() => { this.setOpenPrint(false) }} open={openPrint} >
            <DialogTitle onClose={() => { this.setOpenPrint(false) }}>
              Guia { folio ? folio : '' }
            </DialogTitle>
            <DialogContent dividers >
              <div>
                {
                  pdfURL !== '' && (
                    <>
                      <div className='pdf-viewer'>
                        <Pdf pdfUrl={pdfURL} />
                      </div>

                      <div style={{ padding: '10px 15px 0', display: 'flex', width: '100%', justifyContent: 'space-between' }} >
                        <Button
                          variant="contained"
                          onClick={() => {
                            this.setState({
                              openPrint: false,
                              loadingVisImp,
                              pdfURL: '',
                            });
                            /* if (modo !== 'edit') {
                              this.props.history.push(`/Guias/Todas`);
                            } */
                          }}
                        >
                          Cerrar
                        </Button>
                        <Button
                          disabled={loadingAccpImp}
                          variant="contained"
                          endIcon={<Icon>print</Icon>}
                          onClick={() => {type_print === 'etq' ? this.handlePrintPdfEtiqueta() : this.handleAcceptPrint()  }}
                        >
                          Imprimir
                        </Button>
                      </div>
                    </>
                  )
                }
              </div>
            </DialogContent>
          </Dialog>

          {/* MODAL ALERTA */}
          <Dialog
            open={alertDialog.open}
            onClose={() => { this.setAlertDialog({ ...alertDialog, open: false }); alertDialog.onCancel() }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{alertDialog.title}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {alertDialog.content}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => { this.setAlertDialog({ ...alertDialog, open: false }); alertDialog.onCancel() }} color="primary">
                Cerrar
            </Button>
            <Button onClick={alertDialog.onAccept} color="primary" autoFocus disabled={disabledLoading} >
              Aceptar
            </Button>
            </DialogActions>
          </Dialog>

          {/* Impresion Etiquetas */}
           <Dialog onClose={() => { this.setOpenEtq(false) }} open={openEtq}>
            <DialogTitle onClose={() => { this.setOpenEtq(false) }}>
              Imprimir Etiquetas
            </DialogTitle>
            <DialogContent dividers>
              <div>
                <h5>Recuerda usar la impresora TSC</h5>
              </div>
              <div>
                <TextField
                  inputProps={
                    { min: 1 }
                  }
                  variant="outlined"
                  className="form-field"
                  type={'number'}
                  label={"Numero de Etiquetas"}
                  value={cantEtiquetas}
                  onChange={(e) => { this.setCantEtiquetas(e.target.value) }}
                />
              </div>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => { this.setOpenEtq(false) }}
                variant="contained"
                color={'default'}
              >
                Cancelar
              </Button>
              <Button
                disabled={loadingAccEtq}
                onClick={() => { this.handlePrintEtiqueta() }}
                variant="contained"
                color={'primary'}
              >
                Imprimir
              </Button>
            </DialogActions>
          </Dialog> 

          {/* SNACKBAR MESSAGES */}
          <Snackbar
            open={snackbar.open}
            onClose={() => { this.setSnackbar({ open: false, message: '' }) }}
            autoHideDuration={6000}
            Contentprops={{
              'aria-describedby': 'message-id',
            }}
            message={<span id="message-id">{snackbar.message}</span>}
          />

        </div>
      </div>
    )
  }
}

AccionesGuia.contextType = AuthContext;
export default AccionesGuia